import { createFileRoute } from '@tanstack/react-router';
import { EmployeeForm } from '@/features/employees/components';
import { Header } from '@/components/layout/header';
import { Main } from '@/components/layout/main';
import { ProfileDropdown } from '@/components/profile-dropdown';
import { Search } from '@/components/search';
import { ThemeSwitch } from '@/components/theme-switch';

export const Route = createFileRoute('/_authenticated/employees/new')({
  component: NewEmployeeRoute,
});

function NewEmployeeRoute() {
  return (
    <>
      <Header fixed>
        <Search />
        <div className='w-full flex justify-end items-center space-x-4'>
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>

      <Main>
        <div className='mb-2'>
          <h2 className='text-2xl font-bold tracking-tight'>Add New Employee</h2>
          <p className='text-muted-foreground'>
            Create a new employee profile.
          </p>
        </div>
        <div className='-mx-4 flex-1 overflow-auto px-4 py-1'>
          <EmployeeForm />
        </div>
      </Main>
    </>
  );
} 